export default __webpack_public_path__ + "static/media/ol.83cf73e2.jpg";